import './InitialView.scss';
import React from 'react';
import InitialActionButtons from '../../components/initialActionButtons/InitialActionButtons';
import { useTranslation } from 'react-i18next';
import Config from '../../js/config/_global';
import Logo from '../../components/logo/Logo';
import ImageStatic from '../../components/imageStatic/ImageStatic';
import { useNavigate } from 'react-router';

const InitialView = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const onLoginClick = () => {
        navigate(Config.defaultUrls.grp);
    };

    return (
        <div className="b-view">
            <div className="full content">
                <ImageStatic
                    imagePath='./assets/landing-image'
                    altText={`${Config.clientName.toLowerCase()}-landing-image`}
                    classnames='background-image'
                />
                <Logo classNames='medium-right' isLoginPage={true} />
                <h1 className="initial-title" data-testid="landing-title">
                    {`${t('welcome_text')} ${Config.clientName}`}
                    <span className="version" data-testid="app-version"> {Config.version}</span>
                </h1>
                <InitialActionButtons
                    onLoginClick={onLoginClick}
                />
            </div>
        </div>
    );
};

export default InitialView;
